module.exports = __webpack_public_path__ + "static/media/icon-dashboard-funded.ad9d3639.svg";